<script>
import events from './events'
import { i18nRender } from '@/locales'
import i18nMixin from '@/store/i18n-mixin'

export default {
  name: 'MultiTab',
  mixins: [i18nMixin],
  data () {
    return {
      pages: [],
      activeIndex: 0
    }
  },
  computed: {
    homeRoute () {
      return {
        fullPath: '/index',
        path: '/index',
        meta: {
          title: 'route.home'
        }
      }
    }
  },
  created () {
    // bind event
    events.$on('open', val => {
      if (!val) {
        throw new Error(`multi-tab: open tab ${val} err`)
      }
      this.activeIndex = val
    }).$on('close', val => {
      if (!val) {
        this.closeThat(this.activeIndex)
        return
      }
      this.closeThat(val)
    }).$on('rename', ({ key, name }) => {
      try {
        const item = this.pages.find(item => item.path === key)
        item.meta.customTitle = name
        this.$forceUpdate()
      } catch (e) {
      }
    })
    if (this.homeRoute.path !== this.$route.path) {
      this.pages.push(this.homeRoute)
    }
    this.pages.push(this.$route)
    this.selectedLastPath()
    this.$store.pages = this.pages;
  },
  methods: {
    onEdit (targetKey, action) {
      this[action](targetKey)
    },
    remove (targetIndex) {
      this.$store.dispatch('tagsView/delCachedView', this.pages[targetIndex])
      this.pages.splice(targetIndex, 1)
      // 判断当前标签是否关闭，若关闭则跳转到最后一个还存在的标签页
      if (this.activeIndex === targetIndex) {
        this.selectedLastPath()
      } else if (this.activeIndex > targetIndex) {
        this.activeIndex--
      }
      this.$store.pages = this.pages;
    },
    selectedLastPath () {
      this.activeIndex = this.pages.length - 1
      const page = this.pages[this.activeIndex]
      if (page.name) {
        this.$store.dispatch('tagsView/addCachedView', page)
      }
      this.$router.push({ path: page.path, query: page.query, params: page.params })
    },

    // content menu
    closeThat (e) {
      // 判断是否为最后一个标签页，如果是最后一个，则无法被关闭
      if (this.pages.length > 1) {
        this.remove(e)
      } else {
        this.$message.info(this.$t('tab.lastTabCannotClose'))
      }
    },
    closeLeft (e) {
      if (e > 1) {
        for (let index = 1; index < e; index++) {
          this.remove(1)
        }
      } else {
        this.$message.info(this.$t('tab.noLeftTabs'))
      }
    },
    closeRight (e) {
      if (e < (this.pages.length - 1)) {
        while (e < this.pages.length - 1) {
          this.remove(e + 1)
        }
      } else {
        this.$message.info(this.$t('tab.noRightTabs'))
      }
    },
    closeAll (e) {
      while (this.pages.length > 1) {
        this.remove(1)
      }
    },
    closeMenuClick (key, route) {
      this[key](route)
    },
    renderTabPaneMenu (e, index) {
      return (
        <a-menu {...{ on: { click: ({ key, item, domEvent }) => { this.closeMenuClick(key, index) } } }}>
          <a-menu-item disabled={index === 0} key="closeThat">{this.$t('tab.closeCurrent')}</a-menu-item>
          <a-menu-item disabled={this.pages.length === index + 1} key="closeRight">{this.$t('tab.closeRight')}</a-menu-item>
          <a-menu-item disabled={index <= 1} key="closeLeft">{this.$t('tab.closeLeft')}</a-menu-item>
          <a-menu-item disabled={this.pages.length === 1} key="closeAll">{this.$t('tab.closeAll')}</a-menu-item>
        </a-menu>
      )
    },
    // render
    getMenuLabel (label) {
      // 菜单名称国际化映射
      const menuLabelMap = {
        '短剧管理': this.$t('menu.videoManagement'),
        '短剧列表': this.$t('menu.videoList'),
        '弹幕管理': this.$t('menu.barrageManagement'),
        '宣传片管理': this.$t('menu.publicizeManagement'),
        '敏感词管理': this.$t('menu.sensitiveWordManagement'),
        '短剧分类管理': this.$t('menu.videoCategoryManagement'),
        '用户购买剧集列表': this.$t('menu.userBuyVideoList'),
        '用户管理': this.$t('menu.userManagement'),
        '用户信息': this.$t('menu.userInfo'),
        '用户提现': this.$t('menu.userWithdraw'),
        '用户反馈': this.$t('menu.userFeedback'),
        '用户注销管理': this.$t('menu.userCancelManagement'),
        '用户报表': this.$t('menu.userReport'),
        '用户权益': this.$t('menu.userRights'),
        '兑换码': this.$t('menu.exchangeCode'),
        '拉人奖励配置': this.$t('menu.referralRewardConfig'),
        '会员购买列表': this.$t('menu.vipPurchaseList'),
        '签到配置': this.$t('menu.signConfig'),
        '任务奖励管理': this.$t('menu.taskRewardManagement'),
        '充值管理': this.$t('menu.rechargeManagement'),
        '充值菜单管理': this.$t('menu.rechargeMenuManagement'),
        '会员菜单管理': this.$t('menu.vipMenuManagement'),
        '资源位配置': this.$t('menu.resourcePositionConfig'),
        '网址管理': this.$t('menu.urlManagement'),
        '帮助中心': this.$t('menu.helpCenter'),
        '引导页': this.$t('menu.guidePage'),
        '分销配置': this.$t('menu.distributionConfig'),
        '轮播图管理': this.$t('menu.carouselManagement'),
        '搜索词管理': this.$t('menu.searchWordManagement'),
        '头像管理': this.$t('menu.avatarManagement'),
        'Tabbar管理': this.$t('menu.tabbarManagement'),
        '手机区号管理': this.$t('menu.mobileCodeManagement'),
        '财务报表': this.$t('menu.financialReport'),
        '短剧报表': this.$t('menu.videoReport'),
        '金币充值订单列表': this.$t('menu.coinRechargeOrderList'),
        '版本更新': this.$t('menu.versionUpdate'),
        '版本管理': this.$t('menu.versionManagement'),
        '系统管理': this.$t('menu.systemManagement'),
        '用户查询': this.$t('menu.userQuery'),
        '用户新增': this.$t('menu.userAdd'),
        '用户修改': this.$t('menu.userEdit'),
        '用户删除': this.$t('menu.userDelete'),
        '用户导出': this.$t('menu.userExport'),
        '用户导入': this.$t('menu.userImport'),
        '重置密码': this.$t('menu.resetPassword'),
        '角色管理': this.$t('menu.roleManagement'),
        '角色查询': this.$t('menu.roleQuery'),
        '角色新增': this.$t('menu.roleAdd'),
        '角色修改': this.$t('menu.roleEdit'),
        '角色删除': this.$t('menu.roleDelete'),
        '脱敏权限': this.$t('menu.maskPermission'),
        '菜单管理': this.$t('menu.menuManagement'),
        '菜单查询': this.$t('menu.menuQuery'),
        '菜单新增': this.$t('menu.menuAdd'),
        '菜单修改': this.$t('menu.menuEdit'),
        '菜单删除': this.$t('menu.menuDelete'),
        '参数设置': this.$t('menu.paramSettings'),
        '参数查询': this.$t('menu.paramQuery'),
        '参数新增': this.$t('menu.paramAdd'),
        '参数修改': this.$t('menu.paramEdit'),
        '参数删除': this.$t('menu.paramDelete'),
        '参数导出': this.$t('menu.paramExport'),
        '通知公告': this.$t('menu.noticeAnnouncement'),
        '公告查询': this.$t('menu.noticeQuery'),
        '公告新增': this.$t('menu.noticeAdd'),
        '公告修改': this.$t('menu.noticeEdit'),
        '公告删除': this.$t('menu.noticeDelete'),
        '日志管理': this.$t('menu.logManagement'),
        '操作日志': this.$t('menu.operationLog'),
        '操作查询': this.$t('menu.operationQuery'),
        '操作删除': this.$t('menu.operationDelete'),
        '日志导出': this.$t('menu.logExport'),
        '登录日志': this.$t('menu.loginLog'),
        '登录查询': this.$t('menu.loginQuery'),
        '登录删除': this.$t('menu.loginDelete'),
        '账户解锁': this.$t('menu.accountUnlock'),
        '系统工具': this.$t('menu.systemTools'),
        '表单构建': this.$t('menu.formBuilder'),
        '代码生成': this.$t('menu.codeGeneration'),
        '生成查询': this.$t('menu.generateQuery'),
        '生成修改': this.$t('menu.generateEdit'),
        '生成删除': this.$t('menu.generateDelete'),
        '导入代码': this.$t('menu.importCode'),
        '预览代码': this.$t('menu.previewCode'),
        '生成代码': this.$t('menu.generateCode'),
        '系统接口': this.$t('menu.systemInterface'),
        '数据库文档': this.$t('menu.databaseDoc'),
        '系统监控': this.$t('menu.systemMonitor'),
        '数据监控': this.$t('menu.dataMonitor'),
        '服务监控': this.$t('menu.serviceMonitor'),
        '缓存监控': this.$t('menu.cacheMonitor'),
        '缓存列表': this.$t('menu.cacheList')
      }
      // 如果 title 是国际化键值（以 route. 开头），直接使用 i18nRender
      if (label && label.startsWith && label.startsWith('route.')) {
        return i18nRender(label)
      }
      // 如果 title 在映射表中，使用映射的国际化文本
      return menuLabelMap[label] || i18nRender(label) || label
    },
    renderTabPane (title, keyPath, index) {
      const menu = this.renderTabPaneMenu(keyPath, index)

      return (
        <a-dropdown overlay={menu} trigger={['contextmenu']}>
          <span style={{ userSelect: 'none' }}>{ this.getMenuLabel(title) } </span>
        </a-dropdown>
      )
    }
  },
  watch: {
    '$route': function (newVal) {
      let currentIndex = this.pages.findIndex((item) => item.path === newVal.path)
      if (currentIndex < 0) {
        this.pages.push(newVal)
        currentIndex = this.pages.length - 1
      } else {
        const page = this.pages[currentIndex]
        // 判断fullPath及params，因fullPath会包含query，无需判断query
        if (page.fullPath !== newVal.fullPath || JSON.stringify(page.params) !== JSON.stringify(newVal.params)) {
          this.pages.splice(currentIndex, 1, newVal)
        }
      }
      this.activeIndex = currentIndex
    },
    activeIndex: function (index) {
      const page = this.pages[index]
      if (page.name) {
        this.$store.dispatch('tagsView/addCachedView', page)
      }
      this.$router.push({ path: page.path, query: page.query, params: page.params })
    }
  },
  render () {
    const { onEdit, $data: { pages } } = this
    const panes = pages.map((page, index) => {
      return (
        <a-tab-pane
          style={{ height: 0 }}
          tab={this.renderTabPane(page.meta.customTitle || page.meta.title, page.path, index)}
          key={index} closable={page.path !== this.homeRoute.path}
        >
        </a-tab-pane>)
    })

    return (
      <div class="ant-pro-multi-tab">
        <div class="ant-pro-multi-tab-wrapper">
          <a-tabs
            hideAdd
            type={'editable-card'}
            v-model={this.activeIndex}
            tabBarStyle={{ background: '#FFF', margin: 0, paddingLeft: '16px', paddingTop: '1px' }}
            {...{ on: { edit: onEdit } }}>
            {panes}
          </a-tabs>
        </div>
      </div>
    )
  }
}
</script>
